/**
 * @module websocket.event.handlers.pilots.pilot-updated
 */
import { store } from '../../../../state/store'
import { setPilotItemUpdated } from '../../../../state/websocket.slice'

export default function handlePilotUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handlePilotUpdated', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setPilotItemUpdated(data))
  }
} 